<template>
    <div class="downloadGuide">
        <div class="titleArea">
            <div class="title">推荐下载慧植大当家</div>
            <div class="stitle">功能更全更适合您</div>
        </div>

        <div class="step">
            <div class="left">
                <p>1</p>
            </div>
            <div class="right">
                <p class="title">用户动态信息跟踪管理</p>
                <p class="value">实时掌握用户病虫害及生产情况</p>
                <p class="value">支持一键呼叫，实现精准销售。</p>
            </div>
        </div>

        <div class="step">
            <div class="left">
                <p>2</p>
            </div>
            <div class="right">
                <p class="title">用户实时聊天功能</p>
                <p class="value">支持农户一对一实时聊天</p>
                <p class="value">可精准推送产品信息和解决方案</p>
                <p class="value">把农民会搬到手机里</p>
            </div>
        </div>

        <div class="step">
            <div class="left">
                <p>3</p>
            </div>
            <div class="right">
                <p class="title">农资店信息发布功能</p>
                <p class="value">自主发布产品信息，附近农户在线可见</p>
                <p class="value">支持电话呼叫和在线下单</p>
            </div>
        </div>
        <div class="step">
            <div class="left">
                <p>4</p>
            </div>
            <div class="right">
                <p class="title">农户信息管理功能</p>
                <p class="value">专属二维码关联农户，汇聚用户资源池</p>
                <p class="value">自定义种植作物、面积等用户信息</p>
            </div>
        </div>

        <div class="step">
            <div class="left">
                <p>5</p>
            </div>
            <div class="right">
                <p class="title">病虫害AI识别功能</p>
                <p class="value">拍照识别病虫害，田间识别准确率85%以上</p>
                <p class="value">并实时跟踪农户自主识别结果</p>
            </div>
        </div>

        <div class="qrcode">
            <div class="img">
                <img src="@/assets/downloadGuide/qrcode@2x.png" alt="">
            </div>
            <p>扫描上面二维码</p>
            <p>立即申请慧植大当家账号</p>
        </div>

        <div class="bgMobile">
        </div>
    </div>
</template>

<script>

  export default {
    data() {
      return {

      }
    },
    created() {
      const {fromId} = this.$route.query || {}
      this.fromUserId = fromId
    },
    mounted() {

    },
    methods: {

    }
  }
</script>

<style lang="scss" scoped>
    @import '@/styles/downloadGuide/index';
</style>
